
// prod 代码分析
const report = process.env.NODE_ENV === 'report'

// dev 本地环境
const dev = process.env.NODE_ENV === 'development'

export default { report, dev }
